import request from "@/utils/request";

export function personalCenterApi() {
    return request({
      url: "/admin/personal_center",
      method: "get",
    });
  }

export function getNoticeMissionApi() {
    return request({
      url: "/admin/get_notice_mission",
      method: "post",
    });
 }